var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomweb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 101.91",
    style: {
      enableBackground: "new 0 0 122.88 101.91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.34,0h116.2c1.84,0,3.34,1.5,3.34,3.34v76.98c0,1.84-1.5,3.34-3.34,3.34H3.34C1.5,83.66,0,82.16,0,80.32 V3.34C0,1.5,1.5,0,3.34,0L3.34,0L3.34,0z M12.57,11.68h9.82v2.56h-9.82V11.68L12.57,11.68z M27.07,38.8h-14.5v-2.57h14.5V38.8 L27.07,38.8z M46.8,38.81H30.02v-2.58H46.8V38.81L46.8,38.81z M75.66,38.81H49.64v-2.57h26.03V38.81L75.66,38.81z M37.25,28.07 H88.4v2.53H37.25V28.07L37.25,28.07z M25.22,28.05h9.26v2.56h-9.26V28.05L25.22,28.05z M12.57,28.05h9.82v2.56h-9.82V28.05 L12.57,28.05z M34.77,22.41H12.57v-2.54h22.21V22.41L34.77,22.41z M46.8,22.42h-9.26v-2.56h9.26V22.42L46.8,22.42z M75.66,22.43 H49.64v-2.57h26.03V22.43L75.66,22.43z M37.25,11.68h22.21v2.54H37.25V11.68L37.25,11.68z M25.22,11.68h9.26v2.56h-9.26V11.68 L25.22,11.68z M91.2,62.08l-9.1-5.1v-2.92l9.1-5.1v3.36l-6.34,3.16l6.34,3.26V62.08L91.2,62.08z M92.89,64.35l3.29-17.91h1.91 l-3.31,17.91H92.89L92.89,64.35z M99.48,62.1v-3.34l6.35-3.2l-6.35-3.24V49l9.1,5.14v2.88L99.48,62.1L99.48,62.1z M46.29,88.27 h30.3c0.08,5.24,2.24,9.93,8.09,13.63H38.2C42.88,98.51,46.31,94.39,46.29,88.27L46.29,88.27L46.29,88.27z M61.44,72.41 c2.37,0,4.29,1.92,4.29,4.29c0,2.37-1.92,4.29-4.29,4.29c-2.37,0-4.29-1.92-4.29-4.29C57.15,74.33,59.07,72.41,61.44,72.41 L61.44,72.41z M10.05,6.29h102.79c1.63,0,2.95,1.33,2.95,2.95v57.52c0,1.62-1.33,2.95-2.95,2.95H10.05c-1.62,0-2.95-1.33-2.95-2.95 V9.24C7.09,7.62,8.42,6.29,10.05,6.29L10.05,6.29L10.05,6.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomweb);
export default __webpack_public_path__ + "static/media/customweb.c5dd627fbd8bb52d47a3bca4241f53db.svg";
export { ForwardRef as ReactComponent };